import { render, staticRenderFns } from "./CotTracciamentoChiamateListComponent.vue?vue&type=template&id=c1b09ec6"
import script from "./CotTracciamentoChiamateListComponent.vue?vue&type=script&lang=js"
export * from "./CotTracciamentoChiamateListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports